import React from 'react';
import { cn } from '@/lib/utils';
import { AudioPlayer } from './AudioPlayer';

interface UserMessageBubbleChatbotProps {
  content: string;
  audio?: string | null;
  timestamp?: Date;
}

const UserMessageBubbleChatbot = React.memo(function UserMessageBubbleChatbot({
  content,
  audio,
  timestamp,
}: UserMessageBubbleChatbotProps) {
  return (
    <div className="flex w-full justify-end animate-in fade-in-50 slide-in-from-bottom-2 duration-300">
      <div className="flex flex-col items-end max-w-[75%]">
        <div className={cn(
          'rounded-2xl px-4 py-3 shadow-sm transition-all duration-200',
          'bg-primary text-primary-foreground rounded-tr-sm'
        )}>
          {audio ? (
            <div className="py-1">
              <AudioPlayer audioData={audio} from="client" />
              {timestamp && (
                <div className="text-[10px] mt-2 flex items-center text-primary-foreground/70 justify-end">
                  {timestamp.toLocaleTimeString('es-AR', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </div>
              )}
            </div>
          ) : (
            <>
              <p className="whitespace-pre-wrap break-words m-0 leading-relaxed">
                {content}
              </p>
              
              {timestamp && (
                <div className="text-[10px] mt-2 flex items-center text-primary-foreground/70 justify-end">
                  {timestamp.toLocaleTimeString('es-AR', {
                    hour: '2-digit',
                    minute: '2-digit',
                  })}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
});

export default UserMessageBubbleChatbot;
